import React from "react";
import { Link } from "react-router-dom";

const WaitingScreen = () => {
  return (
    <>
      {/* <div>
        <div className="px-5 space-y-2.5">
          <p>
            Thank you for your patience. Your account is under review to ensure it
            meets our standards.
          </p>
          <p>We will notify you via email once we review.</p>

          <p>For questions, email us at support@fireduptovote.com.</p>
        </div>

        <div className="w-full h-[1px] bg-[#e5e7eb]"></div>

        <div className="w-full px-4 flex justify-end gap-2">
          <Link
            to="/"
            className="h-9 rounded-md bg-cherry text-white hover:bg-white hover:text-cherry transition-all duration-200 border border-cherry px-[22px] font-semibold relative disabled:cursor-not-allowed disabled:bg-cherry disabled:text-white disabled:opacity-70 flex items-center"
          >
            Home
          </Link>
        </div>
      </div> */}
      <div className="w-full px-20px max-w-[944px] font-fira xl:mt-[232px] lg:mt-[190px] mt-[140px] mx-auto lg-xl:mb-20 lg:mb-15 mb-10">
        <div className="border border-[#CCCCCC] rounded-[16px] p-4 lg:p-[40px]">
          <h1 className="font-bold lg-xl:text-[50px] lg-xl:leading-[65px] lg:text-[40px] lg:leading-[55px] sm:text-[32px] sm:leading-[45px] text-[28px] leading-[40px] text-lightBlack tracking-normal uppercase font-fira text-center">ACCOUNT SETUP</h1>
          
          <div className="text-left my-[20px]">
            <p className="xl:text-22px xl:leading-[28.6px] text-[20px] leading-normal font-fira font-normal tracking-[-0.02px] text-lightBlack pb-[10px]">Thank you for your patience. Your account is under review to ensure it meets our standards.</p>
            <p className="xl:text-22px xl:leading-[28.6px] text-[20px] leading-normal font-fira font-normal tracking-normal text-lightBlack pb-[10px]">We will notify you via email once we review.</p>
            <p className="xl:text-22px xl:leading-[28.6px] text-[20px] leading-normal font-fira font-normal tracking-normal text-lightBlack">
              For questions, email us at <span className="font-semibold">support@fireduptovote.com</span>
            </p>
          </div>
          
          <button className="uppercase lg:ml-auto lg:mr-0 ml-auto mr-auto  xl:text-22px xl:leading-[23.4px] text-18px font-fira font-normal hover:bg-darkRed bg-customRed text-white flex items-center xl:py-[14.3px] xl:px-6 py-2 px-3 leading-[23.4px] cursor-pointer">
            <Link
              to="/"
              className="text-[22px]"
            >
              Home
            </Link>
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-[20px]" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
            </svg>
          </button>
        </div>
      </div>
    </>
  );
};

export default WaitingScreen;
